/**
 * @namespace Slider
 * @aka Planet.Slider
 */
Planet.Slider = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'slider';
  var DATA_KEY = 'planet.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  // Der Selektor geht auf die gesamte Suche!
  var Selector = {
    DATA_SPY: '#planet-klassen'
  };

  /*
   TODO: private helpers go here.
   */

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Slider = function () {

    function Slider(element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);

      self._slider();
    }

    Slider.prototype._slider = function _slider() {
      var self = this;

      var inactiveColor = "#cacaca";
      //var activeColor = "#12a1cb";
      var activeColor = "#4178f5";

      var sliderOne = document.getElementById("slider-1");
      var sliderTwo = document.getElementById("slider-2");
      var displayValOne = document.getElementById("range1");
      var displayValTwo = document.getElementById("range2");
      var displayValDash = document.getElementById("dash");
      var minGap = 0;
      var sliderTrack = document.querySelector(".slider-track");
      var sliderMaxValue = document.getElementById("slider-1").max;

      //  generiere die Ul / li on the fly und schreibe in Container
      var rangelistcontainer = document.getElementById("long-values");
      var list = document.createElement("ul");

      list.classList.add("valuelist");
      rangelistcontainer.appendChild(list);

      // hole die Anzahl aus dem  data-attribut des sliderOne
      for (var i = 1; i <= sliderTrack.getAttribute("data-steps"); i++) {
        var radio = document.createElement("input");
        var label = document.createElement("label");
        var listitem = document.createElement("li");

        listitem.setAttribute("data-range", i);
        listitem.classList.add("listitem");

        radio.setAttribute("type", "radio");
        radio.setAttribute("name", "klasse");
        radio.setAttribute("id", "id" + i);
        radio.setAttribute("value", i);
        radio.setAttribute("data-value", i);
        label.setAttribute("for", "id" + i);
        label.innerText = i;

        listitem.appendChild(radio);
        listitem.appendChild(label);
        list.appendChild(listitem);
      }

      function slideMe() {
        if (parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap) {
          sliderOne.value = parseInt(sliderTwo.value) - minGap;
        } else if (parseInt(sliderTwo.value) - parseInt(sliderOne.value) <= minGap) {
          sliderTwo.value = parseInt(sliderOne.value) + minGap;
        }

        setUntilText();
        fillColor();
        reset();
        getRange(sliderOne.value, sliderTwo.value);
        equalVal();
      }

      function setUntilText() {
        if (parseInt(sliderTwo.value) - parseInt(sliderOne.value) != "0") {
          displayValOne.textContent = sliderOne.value;
          displayValTwo.textContent = sliderTwo.value;
          displayValDash.textContent = ". - ";
        } else {
          displayValOne.textContent = "";
          displayValDash.textContent = "";
        }
      }

      function equalVal() {
        // Wenn die beiden Elemente übereinanderliegen, dann soll der untere leicht nach links verschoben werden.
        if (sliderOne.value == sliderTwo.value) {
          sliderOne.style.marginLeft = "-12px";
        } else {
          sliderOne.style.marginLeft = "0";
        }
      }

      function fillColor() {
        var percent1 = ((sliderOne.value - 1) / (sliderMaxValue - 1)) * 100;
        var percent2 = ((sliderTwo.value - 1) / (sliderMaxValue - 1)) * 100;
        sliderTrack.style.background = `linear-gradient(to right, ${inactiveColor} ${percent1}% , ${activeColor} ${percent1}% , ${activeColor} ${percent2}%, ${inactiveColor} ${percent2}%)`;
      }

      // die Listenelemente werden markiert
      function getRange(start, end) {
        var len = end - start;

        var listelements = document.querySelectorAll("li.listitem");
        for (var i = 0; i <= len; i++) {
          var item = parseInt(start - 1) + parseInt(i);
          listelements[item].classList.add("slideractive");
        }
      }

      function setRange(val) {
        sliderOne.value = val;
        sliderTwo.value = val;
        sliderTrack.style.background = inactiveColor;
      }

      // nicht mehr markierte Listenelemente verlieren die Klasse
      function reset() {
        var listelements = document.querySelectorAll("li.listitem");
        Array.prototype.forEach.call(listelements, function (el) {
          el.classList.remove("slideractive");
        });
      }

      // Eine Klasse anklicken (Radiobutton)
      function clickMe() {
        var radios = document.querySelectorAll(".valuelist input[type='radio']");
        radios.forEach(function (radio) {
          radio.addEventListener("click", function (e) {
            var val = e.target.getAttribute("data-value");
            reset();
            getRange(val, val);
            setRange(val);
            equalVal();
            // Radiobutton wieder abhaken, damit der Wert on submit nicht mitgeschickt wird, wir brauchen nur das click event
            this.checked = false;
            // Dadurch müssen wir aber das change event manuell triggern, damit der "Filter anwenden" Button enabled wird (searchfilter.js)
            $('#planet-klassen').trigger('change');
          });
        });
      }

      function attachMe() {
        var slider = document.querySelectorAll(".rangeslider");
        slider.forEach(function (item) {
          item.addEventListener("input", function () {
            slideMe();
          });
        });
      }

      slideMe();
      clickMe();
      attachMe();
    };


    // public
    Slider.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    Slider._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Slider(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return Slider;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    Slider._jQueryInterface.call($element, $element.data());
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      Slider._jQueryInterface.call($element, $element.data());
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Slider._jQueryInterface;
  $.fn[NAME].Constructor = Slider;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Slider._jQueryInterface;
  };

  return Slider;

})(window.jQuery);
